import { LegendComponent } from './LegendComponent';
import { TableComponent } from './TableComponent';

import styles from './PageComponent.module.scss';
import { AdsComponent } from 'shared/components/ads';

export const PageDesktopComponent = () => {
	return (
		<div className={styles.map_structure_desktop}>
			<div className="title">
				<h1>Кликабельная карта всех ETF на Московской Бирже</h1>
			</div>
			<div className="legend">
				<LegendComponent />
			</div>
			<div className="table">
				<TableComponent />
			</div>
			<div className="ad-desktop-1">
				<AdsComponent id="MapFirst:desktop" isVertical={true} />
			</div>
			<div className="ad-desktop-2">
				<AdsComponent id="MapSecond:desktop" isVertical={false} />
			</div>
		</div>
	);
}

export const PageCompactComponent = () => {
	return (
		<div className={styles.map_structure_compact}>
			<div className="ad-compact-1">
				<AdsComponent id="MapFirst:mobile" isVertical={false} />
			</div>

			<div className="table">
				<TableComponent />
			</div>
			<div className="legend">
				<LegendComponent />
			</div>
			<div className="ad-compact-2">
				<AdsComponent id="MapSecond:mobile" isVertical={false} />
			</div>
		</div>
	);
}